import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface PatienthighriskParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface PatientHighriskMst {

    id?: number;     
    
    visitId:any;
    regId: string;
    date:Date;
    highRiskId: any; 
    tenantId: any;
    branchId: any;
    
    parameters?: PatienthighriskParameter[];
    links?: any;
    //Log
    createdDate?:Date;
    updatedDate?:Date;
    createdBy?:number;
    updatedBy?:number;
    createdIP?:string;
    updatedIP?:string;

}

export abstract class PatienthighriskData { 

    abstract list(url: string): Observable<PatientHighriskMst[]>;
    abstract create(url: string, data: PatientHighriskMst): Observable<any>;
    abstract update(url: string, data: PatientHighriskMst): Observable<any>;
    abstract delete(url: string): Observable<any>;    
}
